/* 删除数组属性为空 */
export const deleteNullKey = (obj: any) => {
  // obj为undefined时，返回空对象
  if (obj === undefined) {
    return {}
  }
  Object.keys(obj).forEach((item) => {
    if (obj[item] === null) {
      delete obj[item]
    }
  })
  return obj
}
/* 正则验证，返回是否匹配 */
export const validateReg = (value: string | number, reg: string): boolean => {
  try {
    const regex = new RegExp(reg)
    return regex.test(String(value))
  } catch {
    console.warn('无效的正则表达式:', reg)
    return false
  }
}
// 排序的函数
export const objKeySort = (obj: any) => {
  const sortObj = {} as any
  let Objarr: any = {} as any
  const arrChild: {}[] = []
  Object.keys(obj)
    .sort()
    .forEach((item) => {
      if (obj[item] instanceof Array) {
        obj[item].forEach((index: number) => {
          if (typeof index === 'object') {
            Object.keys(index)
              .sort()
              .forEach((indexKey) => {
                Objarr[indexKey] = index[indexKey]
              })
            arrChild.push(Objarr)
            Objarr = {} // 每push一次把对象中的值清空一次
            obj[item] = arrChild // 把排好序的重新赋值
          }
        })
      }
      sortObj[item] = obj[item] // 最外面对象排序赋值
    })
  return sortObj
}